import styled from 'styled-components';
import { Anchor } from 'antd';

export const AnchorElement = styled(Anchor)`
  transition: all 0.3s ease-in-out;
  padding-top:${props => props.scrolled ? '120px': ''};
`;

export const NavigationLi = styled.li`
  padding-left: 20px;
  margin-bottom: 15px;

  a { 
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #828282;
    cursor: pointer;
    text-decoration: none;

    ${props => props.colored ? `
      // background: linear-gradient(225deg, #89DD65 0%, #AEDD65 100%);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
      a {
        color: #89DD65;
      }
    ` : ''};

    &:hover {
      /* background: linear-gradient(225deg, #89DD65 0%, #AEDD65 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent; */
      color: #89DD65;
    }
  }


  .ant-anchor-link-active {
      /* background: linear-gradient(225deg, #89DD65 0%, #AEDD65 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent; */
      a {
        color: #89DD65;
      }
  }
`

export const NavigationUl = styled.ul`
  list-style: none;
  border-left: 0.5px solid #828282;
  padding: 10px 0;
`

export const NavigationHeader = styled.div`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 30px;
`

export const NavigationWrapper = styled.div`
  min-width: 245px;
  margin-right: 63px;
`
